/* hydrus-drawer-scroll.js (Alfred, 2026-10-14)
 * Shows a "More in your cart" pill pinned to the bottom of the cart drawer's scroll area whenever
 * a cart line is cut off below the fold (or there is more to scroll). Tapping it scrolls down.
 * Survives the drawer's innerHTML swaps: everything is looked up fresh on each check.
 */
(function () {
  if (window.__hydrusDrawerScroll) return; window.__hydrusDrawerScroll = true;
  var raf = 0;
  function body() { return document.querySelector('.hydrus-drawer .hydrus-drawer-body'); }
  function check() {
    raf = 0;
    var b = body(); if (!b) return;
    var btn = b.querySelector('[data-hydrus-drawer-more]'); if (!btn) return;
    var label = b.querySelector('[data-hydrus-drawer-more-label]');
    var box = b.getBoundingClientRect();
    var visibleBottom = box.bottom - 8;
    var hidden = 0;
    b.querySelectorAll('.hydrus-drawer-items > li').forEach(function (li) {
      var r = li.getBoundingClientRect();
      if (r.top + Math.min(r.height * 0.5, 60) > visibleBottom) hidden++;
    });
    var more = b.scrollHeight - b.scrollTop - b.clientHeight > 24;
    if (hidden > 0) {
      label.textContent = hidden === 1 ? '1 more item in your cart' : hidden + ' more items in your cart';
      btn.hidden = false;
    } else if (more && b.scrollTop < 40) {
      label.textContent = 'Scroll for more';
      btn.hidden = false;
    } else {
      btn.hidden = true;
    }
  }
  function schedule() { if (!raf) raf = requestAnimationFrame(check); }
  document.addEventListener('scroll', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('hydrus-drawer-body')) schedule();
  }, true);
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-hydrus-drawer-more]');
    if (!btn) return;
    var b = body(); if (!b) return;
    b.scrollBy({ top: Math.round(b.clientHeight * 0.75), behavior: 'smooth' });
  });
  ['cart:refresh', 'cart-drawer:open'].forEach(function (n) {
    document.addEventListener(n, function () { [150, 600, 1500].forEach(function (t) { setTimeout(schedule, t); }); });
  });
  window.addEventListener('resize', schedule);
  var mo = new MutationObserver(schedule);
  function watch() { var d = document.querySelector('.hydrus-drawer'); if (d) mo.observe(d, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { watch(); schedule(); }); else { watch(); schedule(); }
})();
